import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from "@angular/forms";
import { GooglePlaceAutocompleteComponent } from './google-place-autocomplete.component';
@NgModule({
    imports: [CommonModule, FormsModule],
    declarations: [GooglePlaceAutocompleteComponent],
    exports: [GooglePlaceAutocompleteComponent],
    providers: []
})
export class GooglePlaceAutocompleteModule { }


// WEBPACK FOOTER //
// ./src/angular_library/components/google-place-autocomplete/google-place-autocomplete.module.ts